export default __webpack_public_path__ + "static/media/cabinet.5536c38d.webp";